// PDP landing COD: pack de unidades, selector de variantes, skip-cart y sticky ATC.
(function () {
  // Pack de unidades: al seleccionar una tarjeta, fija la VARIANTE-pack del form.
  function initQuantityBreaks(root, form) {
    var qb = root.querySelector('[data-me-qb]');
    if (!qb) return;

    // input cantidad real (Shopify lee name="quantity"); lo creamos si no existe
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = '1';
      form.appendChild(qtyInput);
    }
    // input variante (Shopify/Releasit leen name="id"): cada pack es una VARIANTE
    // con su propio precio, así que al elegir un pack cambiamos la variante, no la
    // cantidad. Cantidad siempre = 1.
    var idInput = form.querySelector('.me-product__variant-id') || form.querySelector('input[name="id"]');

    function sync() {
      var checked = qb.querySelector('input[name="me-qty"]:checked');
      var vid = checked ? checked.getAttribute('data-variant-id') : null;
      if (vid && idInput) idInput.value = vid;
      qtyInput.value = '1';
      qb.querySelectorAll('.me-qb__card').forEach(function (c) {
        var r = c.querySelector('input[name="me-qty"]');
        c.classList.toggle('is-selected', !!(r && r.checked));
      });
    }

    qb.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'me-qty') sync();
    });
    sync();
  }

  // Selector de variantes reales (color/talla): actualiza input id, precio y foto.
  // Excluyente con el pack de unidades (un producto tiene variantes O packs).
  function initVariantPicker(root, form) {
    var vp = root.querySelector('[data-me-vp]');
    if (!vp) return;
    var dataEl = vp.querySelector('[data-me-vp-data]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('.me-product__variant-id') || form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('.me-offer__price');
    var compareEl = root.querySelector('.me-offer__compare');
    var saveEl = root.querySelector('.me-offer__save');
    var imgEl = root.querySelector('.me-product__image');

    function selectedValues() {
      var vals = [];
      vp.querySelectorAll('.me-vp__group').forEach(function (g, i) {
        var r = g.querySelector('input[name="me-opt-' + i + '"]:checked');
        vals.push(r ? r.value : null);
      });
      return vals;
    }

    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var j = 0; j < vals.length; j++) {
          if (vals[j] !== null && v.options[j] !== vals[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    // SLIDER LATERAL tipo rueda de iPhone (horizontal): la tarjeta que queda en
    // el CENTRO de la banda es la seleccionada. Deslizar la banda selecciona al
    // asentarse; tocar una tarjeta la centra (y al centrarse queda elegida).
    function centerItem(track, el, instant) {
      // Scroll PROGRAMÁTICO: abrir una ventana de ignorar para que la selección
      // en vivo no "elija" tarjetas intermedias mientras la banda se acomoda
      // sola (centrados, reflow al abrir/cerrar el form COD, resize...).
      track.__meIgnoreUntil = Date.now() + (instant ? 300 : 800);
      var left = el.offsetLeft + el.offsetWidth / 2 - track.clientWidth / 2;
      if (track.scrollTo) track.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
      else track.scrollLeft = left;
    }

    function centerSelected(group, instant) {
      var track = group.querySelector('[data-me-vp-track]');
      var sel = group.querySelector('.me-vp__pill.is-selected');
      if (track && sel) centerItem(track, sel, instant);
    }

    // Padding lateral para que la PRIMERA y la ÚLTIMA tarjeta puedan centrarse
    function padTrack(track) {
      var pills = track.querySelectorAll('.me-vp__pill');
      if (!pills.length) return;
      var first = pills[0], last = pills[pills.length - 1];
      track.style.paddingLeft = Math.max(6, track.clientWidth / 2 - first.offsetWidth / 2) + 'px';
      track.style.paddingRight = Math.max(6, track.clientWidth / 2 - last.offsetWidth / 2) + 'px';
    }

    function sync(skipCenter) {
      var v = findVariant(selectedValues());
      if (!v) return; // combinación inexistente: conserva la última válida
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        if (v.compare) { compareEl.textContent = v.compare; compareEl.style.display = ''; }
        else compareEl.style.display = 'none';
      }
      if (saveEl) {
        if (v.save) { saveEl.textContent = 'Ahorras ' + v.save + ' · ' + v.pct + '% OFF'; saveEl.style.display = ''; }
        else saveEl.style.display = 'none';
      }
      if (imgEl && v.image) {
        imgEl.removeAttribute('srcset');
        imgEl.src = v.image;
      }
      vp.querySelectorAll('.me-vp__pill').forEach(function (p) {
        var r = p.querySelector('.me-vp__radio');
        p.classList.toggle('is-selected', !!(r && r.checked));
      });
      vp.querySelectorAll('.me-vp__group').forEach(function (g) {
        // Título dinámico "Color: Verde" + centrar la tarjeta elegida
        var cur = g.querySelector('[data-me-vp-current]');
        var selR = g.querySelector('.me-vp__radio:checked');
        if (cur && selR) cur.textContent = selR.value;
        if (!skipCenter) centerSelected(g);
      });
    }

    // Cablear cada banda como rueda horizontal
    vp.querySelectorAll('.me-vp__group').forEach(function (g) {
      var track = g.querySelector('[data-me-vp-track]');
      if (!track) return;
      var pills = [].slice.call(track.querySelectorAll('.me-vp__pill'));
      var prev = g.querySelector('[data-me-vp-prev]');
      var next = g.querySelector('[data-me-vp-next]');

      function nearest() {
        var mid = track.scrollLeft + track.clientWidth / 2, best = null, bd = Infinity;
        pills.forEach(function (p) {
          var d = Math.abs(p.offsetLeft + p.offsetWidth / 2 - mid);
          if (d < bd) { bd = d; best = p; }
        });
        return best;
      }

      // Selección EN VIVO solo con GESTO DEL USUARIO: la tarjeta se marca en el
      // instante en que cruza el centro mientras ÉL desliza. Los scrolls que no
      // inicia el usuario (centrado programático, reflow del form COD, resize)
      // NO seleccionan — antes cambiaban la talla sola al abrir el form.
      var raf = null, interacting = false, endT;
      function userTakesControl() {
        interacting = true;
        track.__meIgnoreUntil = 0; // el gesto del usuario manda sobre cualquier animación
        clearTimeout(endT);
      }
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
        track.addEventListener(ev, userTakesControl, { passive: true });
      });
      track.addEventListener('scroll', function () {
        if (!interacting || Date.now() < (track.__meIgnoreUntil || 0)) return;
        clearTimeout(endT);
        endT = setTimeout(function () { interacting = false; }, 180);
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var b = nearest();
          if (!b) return;
          var r = b.querySelector('.me-vp__radio');
          if (r && !r.checked) { r.checked = true; sync(true); }
        });
      }, { passive: true });

      // Flechas ‹ › (desktop): seleccionan la tarjeta anterior/siguiente
      // directamente (el scroll programático ya no selecciona por posición).
      function step(dir) {
        var cur = nearest();
        var i = Math.min(pills.length - 1, Math.max(0, pills.indexOf(cur) + dir));
        var r = pills[i].querySelector('.me-vp__radio');
        if (r && !r.checked) { r.checked = true; sync(); }
        else centerItem(track, pills[i]);
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      // Re-medir y re-centrar cuando cambie el layout: las fotos lazy de las
      // tarjetas cargan DESPUÉS del init y corren los anchos del track.
      function refresh() { padTrack(track); centerSelected(g, true); }
      refresh();
      window.addEventListener('resize', refresh);
      if (document.readyState !== 'complete') window.addEventListener('load', refresh);
      pills.forEach(function (p) {
        var img = p.querySelector('img');
        if (img && !img.complete) img.addEventListener('load', refresh, { once: true });
      });
    });

    // AISLAR el picker del tema base: temas OS 2.0 (ej. Horizon) escuchan los
    // 'change' de variantes a nivel documento y re-renderizan/morfean la página
    // → con nuestro template custom dejaban secciones EN BLANCO al elegir una
    // variante. Capture + stopPropagation: el evento nunca sale del picker.
    // Releasit no depende de este evento (lee input[name=id] al abrir el form).
    vp.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('me-vp__radio')) {
        e.stopPropagation();
        sync(); // tocar una tarjeta: seleccionar + centrarla en su banda
      }
    }, true);
    sync(true);
    // primer render: centrar la selección inicial SIN animación
    vp.querySelectorAll('.me-vp__group').forEach(function (g) { centerSelected(g, true); });
  }

  function initSection(root) {
    var form = root.querySelector('#me-product-form, .me-product__form');
    if (!form) return;

    initQuantityBreaks(root, form);
    initVariantPicker(root, form);

    var skipCart = root.getAttribute('data-skip-cart') === 'true';
    if (skipCart) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[name="add"]');
        if (btn) btn.setAttribute('disabled', 'disabled');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            if (btn) btn.removeAttribute('disabled');
            window.location.href = '/cart';
          });
      });
    }

    var sticky = root.querySelector('[data-me-sticky]');
    if (sticky) {
      var atcBtn = form.querySelector('[name="add"]');
      var stickyBtn = sticky.querySelector('[data-me-sticky-btn]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(atcBtn);
        else form.submit();
      });
      var onScroll = function () {
        var rect = atcBtn ? atcBtn.getBoundingClientRect() : null;
        var show = rect ? (rect.bottom < 0 || rect.top > window.innerHeight) : false;
        if (show) sticky.removeAttribute('hidden'); else sticky.setAttribute('hidden', '');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  document.querySelectorAll('.me-product').forEach(initSection);
})();
